import React from 'react';
import PropTypes from 'prop-types';

const ReceiptSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 21}`}
      height={`${height || 20}`}
      viewBox="0 0 21 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.17799 16.4167C6.86133 15.6834 7.903 15.7417 8.503 16.5417L9.34466 17.6667C10.0197 18.5584 11.1113 18.5584 11.7863 17.6667L12.628 16.5417C13.228 15.7417 14.2697 15.6834 14.953 16.4167C16.4363 18 17.6447 17.475 17.6447 15.2584V5.86669C17.653 2.50835 16.8697 1.66669 13.7197 1.66669H7.41966C4.26966 1.66669 3.48633 2.50835 3.48633 5.86669V15.25C3.48633 17.475 4.70299 17.9917 6.17799 16.4167Z"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.23633 5.83331H13.903"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.06982 9.16669H13.0698"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

ReceiptSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ReceiptSvg;
